import { c as _c } from "react-compiler-runtime";
import { useCallback, useState } from 'react';
import { useCollaborationSidebarActions } from '../store/collaborationSidebarProvider';
import { Metrics } from '../utils/metrics';
import useHasCommentingFeature from './useHasCommentingFeature';
import * as commentingApi from '../api/CommentingV3';
export default function useFetchComments() {
  "use memo";

  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [comments, setComments] = useState(t0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const actions = useCollaborationSidebarActions();
  const hasCommentingFeature = useHasCommentingFeature();
  let t1;
  if ($[1] !== hasCommentingFeature) {
    t1 = t2 => {
      const {
        objectType,
        objectId,
        refetch
      } = t2;
      if (!hasCommentingFeature) {
        return;
      }
      if (!objectId || !objectType) {
        return;
      }
      setLoading(true);
      const timer = Metrics.timer("fetch-comments-cached-duration", {
        object_type: objectType,
        context: "sidebar",
        from_cache: String(!refetch)
      });
      const startTime = performance.now();
      commentingApi.fetchCommentsCached({
        objectType,
        objectId,
        refetch
      }).then(t3 => {
        const {
          results
        } = t3;
        timer.update(performance.now() - startTime);
        setComments(results || []);
        Metrics.counter("fetch-comments-cached-success", {
          object_type: objectType,
          context: "sidebar"
        }).increment();
      }).catch(e => {
        var _networkError;
        timer.update(performance.now() - startTime);
        Metrics.counter("fetch-comments-cached-error", {
          object_type: objectType,
          context: "sidebar",
          status: (_networkError = e.networkError) === null || _networkError === void 0 ? void 0 : _networkError.status
        }).increment();
        setError(e);
      }).finally(() => {
        setLoading(false);
      });
    };
    $[1] = hasCommentingFeature;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const fetchComments = t1;
  let t2;
  if ($[3] !== actions || $[4] !== comments) {
    t2 = t3 => {
      const {
        objectType: objectType_0,
        objectId: objectId_0,
        updatedCommentId
      } = t3;
      const updatedComments = comments.map(comment => {
        if (comment.id === updatedCommentId) {
          return Object.assign({}, comment, {
            read: true
          });
        }
        return comment;
      });
      setComments(updatedComments);
      commentingApi.updateCommentsCache({
        objectType: objectType_0,
        objectId: objectId_0,
        updatedCommentId,
        comments: updatedComments,
        mergeModulesWithRepliesEntry: actions.mergeModulesWithRepliesEntry
      });
    };
    $[3] = actions;
    $[4] = comments;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const updateCache = t2;
  let t3;
  if ($[6] !== comments || $[7] !== error || $[8] !== fetchComments || $[9] !== loading || $[10] !== updateCache) {
    t3 = {
      fetchComments,
      comments,
      error,
      loading,
      updateCache
    };
    $[6] = comments;
    $[7] = error;
    $[8] = fetchComments;
    $[9] = loading;
    $[10] = updateCache;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}